import { omit } from "lodash";

// A row's Source/SourceId/SourceUrl is its provenance identity (ADR-0034) and
// must stay unique in a time report. Periods copied to other days with
// "Repeat on weekdays" must not carry the original row's identity, or the
// server rejects the save with a duplicate row identity error.
export const withoutRowIdentity = <T extends object>(periods: T[]): T[] =>
  (periods ?? []).map((p) => omit(p, ["source", "sourceId", "sourceUrl"]) as T);
